import { useState, useRef } from 'react';
import { Row, Col, Table, Card, CardBody, CardHeader, Button, Input,  Collapse} from 'reactstrap';
import uuid from 'react-uuid';
import './Lmu.css';
import { FaChevronUp, FaChevronDown, FaPlus, FaTrash } from 'react-icons/fa';

const SoilForm = ({ form, editableKeyToFocus }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const [soils, setSoils] = useState(form.soilDetail);
    

    const handleItemExpandCollapse = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    const handleRemoveRow = (index) => {

        const soilToUpdate = [...soils];
        soilToUpdate.splice(index, 1);
        setSoils(soilToUpdate);

        form.soilDetail = soilToUpdate;
    }

    const handleAddRow = (e) => {
        e.preventDefault();
        let soilToUpdate = [...soils];
        soilToUpdate.push({
            lmuId: form.lmuId,
            sMapRef: "",
            groupId: 0,
            orderId: 0,
            drainage: "",
            description: "",
            area: 0.0,
            percentageOfBlock: 0.0,
            isActive: true,
            createdBy:"",
            updatedBy: "",
            id: 0,
            orderlist:[]
        })
        setSoils(soilToUpdate);
    }
    const getSoildOrderList = (groupId) => {
        const selectedSoilGroupName = form.soilMapGroupsList.filter(soilGroup => soilGroup.id == groupId)[0].value
        const filteredSoilOrderList = form.soilMapOrdersList.filter(soilOrder => soilOrder.typeFilter == selectedSoilGroupName);
        return filteredSoilOrderList;

    }

    const handleFieldChange = (e, index) => {
        const name = e.target.name;
        const soilToUpdate = [...soils];

        soilToUpdate[index][name] = e.target.value;
        setSoils(soilToUpdate);
        form.soilDetail = soils;
    };

    return (
        <Card className="my-3">
            <CardHeader className="item-header" onClick={handleItemExpandCollapse}>
                <Row>
                    <Col sm="11"><h6>Soils (Advanced details - from overseer or other system)</h6></Col>
                    <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>
                   
                    <Row className="my-2">
                        <Col sm="12">
                            <Button
                                onClick={(e) => handleAddRow(e)}
                                id="btnAdd"
                                className="btn btn-sm btn-pluse-light">
                                <FaPlus />
                            </Button><br /><br />
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>
                                            S-Map Ref/ Name
                                        </th>
                                        <th>
                                            Group
                                        </th>
                                        <th>
                                            Order
                                        </th>
                                        <th>
                                            Drainage
                                        </th>
                                        <th>
                                            Description
                                        </th>
                                        <th>
                                            Area (Ha)
                                        </th>
                                        <th>
                                            % of the Block
                                        </th>
                                        <th>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        soils.map((soil, idx) =>
                                            <tr key={uuid()}>
                                                <td>
                                                    <Input
                                                        bsSize="sm"
                                                        type="text"
                                                        name="sMapRef"
                                                        value={soils[idx].sMapRef}
                                                        onChange={(e) => {
                                                            editableKeyToFocus.current = idx +'sMapRef';
                                                            handleFieldChange(e,idx) }}
                                                        autoFocus={idx + 'sMapRef'  === editableKeyToFocus.current}/>
                                                </td>
                                                <td>
                                                    <Input
                                                        bsSize="sm"
                                                        id="groupId"
                                                        name="groupId"
                                                        type="select"
                                                        value={soils[idx].groupId}
                                                        onChange={(e) => {
                                                            editableKeyToFocus.current = idx + 'groupId';
                                                            handleFieldChange(e, idx)
                                                        }}
                                                        autoFocus={idx + 'groupId' === editableKeyToFocus.current}
                                                    >
                                                        <option value={0} >Select Group</option>
                                                        {form.soilMapGroupsList?.map(c =>
                                                            <option key={c.id} value={c.id}>{c.value}</option>
                                                        )}

                                                    </Input>
                                                </td>
                                                <td>
                                                    <Input
                                                        bsSize="sm"
                                                        id="orderId"
                                                        name="orderId"
                                                        type="select"
                                                        value={soils[idx].orderId}
                                                        onChange={(e) => {
                                                            editableKeyToFocus.current = idx + 'orderId';
                                                            handleFieldChange(e, idx)
                                                        }}
                                                        autoFocus={idx + 'orderId' === editableKeyToFocus.current}
                                                    >
                                                        <option value={0} >Select Order</option>
                                                        {soils[idx].groupId > 0 &&
                                                            getSoildOrderList(soils[idx].groupId)?.map(c =>
                                                            <option key={c.id} value={c.id}>{c.value}</option>
                                                            )}
                                                    </Input>
                                                </td>
                                                <td>
                                                    <Input
                                                        bsSize="sm"
                                                        type="text"
                                                        name="drainage"
                                                        value={soils[idx].drainage}
                                                        onChange={(e) => {
                                                            editableKeyToFocus.current = idx + 'drainage';
                                                            handleFieldChange(e, idx)
                                                        }}
                                                        autoFocus={idx + 'drainage' === editableKeyToFocus.current} />
                                                </td>
                                                <td>
                                                    <Input
                                                        bsSize="sm"
                                                        type="text"
                                                        name="description"
                                                        value={soils[idx].description}
                                                        onChange={(e) => {
                                                            editableKeyToFocus.current = idx + 'description';
                                                            handleFieldChange(e, idx)
                                                        }}
                                                        autoFocus={idx + 'description' === editableKeyToFocus.current} />
                                                </td>
                                                <td>
                                                    <Input
                                                        bsSize="sm"
                                                        type="number"
                                                        name="area"
                                                        value={soils[idx].area}
                                                        onChange={(e) => {
                                                            editableKeyToFocus.current = idx + 'area';
                                                            handleFieldChange(e, idx)
                                                        }}
                                                        autoFocus={idx + 'area' === editableKeyToFocus.current} />
                                                </td>
                                                <td>
                                                    <Input
                                                        bsSize="sm"
                                                        type="number"
                                                        name="percentageOfBlock"
                                                        value={soils[idx].percentageOfBlock}
                                                        onChange={(e) => {
                                                            editableKeyToFocus.current = idx + 'percentageOfBlock';
                                                            handleFieldChange(e, idx)
                                                        }}
                                                        autoFocus={idx + 'percentageOfBlock' === editableKeyToFocus.current} />
                                                </td>
                                                <td>
                                                    <Button
                                                        onClick={() => handleRemoveRow(idx)}
                                                        id="btnRemove"
                                                        className="btn btn-sm btn-danger">
                                                        <FaTrash />
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    }

                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </Card>
    )
}

export default SoilForm